
import { newLoanConstants, refinanceIncreaseLoanConstants } from "../_constants";

const newLoanInitialState = {
    branchId: null,
    branchDetails: null,
    firstName: null,
    lastName: null,
    monthOfBirth: null,
    dayOfBirth: null,
    yearOfBirth: null,
    dateOfBirth: null,
    email: null,
    confirmEmail: null,
    mobilePhoneNumber: null,
    address: null,
    city: null,
    borrowerState: null,
    zipcode: null,
    primarySourceOfIncome: null,
    income: null,
    payFrequency: null,
    loanAmount: null,
    sendMeFutureOffers: null,
    over18years: null,
    everythingOnAppCorrect: null,
    loanId: null,
    leadId: null,
    fetching: null,
    error: null,
    errorString: null,
    postingData: false,
    refinanceLoading: false,
    ssnItinError: false,
    accountInfoError: false,
    addressInfoError: false,
    preApprovalOffer: null,
    }

export function newLoan(state = newLoanInitialState, action) {
    switch (action.type) {
        case newLoanConstants.NEW_LOAN_APP_LOGGED_IN_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false,
            };
        case newLoanConstants.NEW_LOAN_APP_LOGGED_IN_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false,
            };
        case newLoanConstants.NEW_LOAN_PERSONAL_INFORMATION_REQUEST:
            return {
                ...state,
                city: action.personalInformation.city,
                borrowerState: action.personalInformation.userState,
                zipcode: action.personalInformation.zipCode,
                error: false,
                errorString: "",
                postingData: false
            };
        case newLoanConstants.NEW_LOAN_PERSONAL_INFORMATION_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false,
            };
        case newLoanConstants.NEW_LOAN_FINANCIAL_INFORMATION_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false
            };
        case newLoanConstants.NEW_LOAN_FINANCIAL_INFORMATION_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false,
            };
        case newLoanConstants.NEW_LOAN_AMOUNT_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false
            };
        case newLoanConstants.NEW_LOAN_AMOUNT_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false,
            };
        case newLoanConstants.NEW_LOAN_AMOUNT_BACK_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false
            };
        case newLoanConstants.NEW_LOAN_AMOUNT_BACK_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false,
            };
        case newLoanConstants.NEW_LOAN_FUNDING_REQUEST:
            return {
                ...state,
                bankingAccountNumber: action.bankingAccountNumber,
                bankRoutingNumber: action.bankRoutingNumber,
                error: false,
                errorString: "",
                postingData: false
            };
        case newLoanConstants.NEW_LOAN_FUNDING_FAILURE:
            return {
                ...state,
                error: true,
                errorString: action.errorString,
                postingData: false,
            };
        case newLoanConstants.FIND_AN_OFFICE_REQUEST:
            return {
                branchId: action.branchId,
                branchDetails: action.branchDetails,
                error: false,
                errorString: null,
                postingData: false
            };
        case newLoanConstants.FIND_AN_OFFICE_SUCCESS:
            return {
                error: false,
                errorString: null,
                postingData: false
            };
        case newLoanConstants.FIND_AN_OFFICE_FAILURE:
            return {
                branchId: null,
                branchDetails: null,
                error: true,
                errorString: action.errorString,
                postingData: false
            };
        case newLoanConstants.NEW_LOAN_APP_REQUEST:
            return {
                branchId: action.branchId,
                branchDetails: action.branchDetails,
                error: false,
                errorString: null,
                postingData: true
            };

        case newLoanConstants.NEW_LOAN_APP_SUCCESS:
            return {
                branchDetails: action.branchDetails,
                BranchId: action.BranchId,
                LeadId: action.LeadId,
                UserHash: action.UserHash,
                firstName: null,
                lastName: null,
                monthOfBirth: null,
                dayOfBirth: null,
                yearOfBirth: null,
                dateOfBirth: null,
                email: null,
                confirmEmail: null,
                mobilePhoneNumber: null,
                address: null,
                city: null,
                borrowerState: null,
                zipcode: null,
                primarySourceOfIncome: null,
                income: null,
                payFrequency: null,
                loanAmount: null,
                sendMeFutureOffers: null,
                over18years: null,
                everythingOnAppCorrect: null,
                loanId: null,
                fetching: false,
                error: false,
                errorString: null,
                postingData: false
            };

        case newLoanConstants.NEW_LOAN_APP_FAILURE:
            return {
                branchDetails: action.branchDetails,
                error: true,
                errorString: action.errorString,
                postingData: false
            };

        case newLoanConstants.NEW_LOAN_VALIDATION_FAIL:
            return {
                branchId: action.branchId,
                branchDetails: action.branchDetails,
                error: true,
                errorString: action.errorString,
                postingData: false
            };

        case newLoanConstants.NEW_LOAN_VALIDATION_PASS:
            return {
                branchId: action.branchId,
                branchDetails: action.branchDetails,
                error: false,
                errorString: null,
                postingData: false
            };

        case newLoanConstants.PERSONAL_INFORMATION_REQUEST:
            return {
                firstName: action.firstName,
                lastName: action.lastName,
                monthOfBirth: action.monthOfBirth,
                dayOfBirth: action.dayOfBirth,
                yearOfBirth: action.yearOfBirth,
                dateOfBirth: action.dateOfBirth,
                email: action.email,
                confirmEmail: action.confirmEmail,
                mobilePhoneNumber: action.mobilePhoneNumber,
                address: action.address,
                city: action.city,
                borrowerState: action.borrowerState,
                zipcode: action.zipcode,
                error: false,
                postingData: false
            };
        case newLoanConstants.PERSONAL_INFORMATION_SUCCESS:
            return {
                firstName: null,
                lastName: null,
                monthOfBirth: null,
                dayOfBirth: null,
                yearOfBirth: null,
                dateOfBirth: null,
                email: null,
                confirmEmail: null,
                mobilePhoneNumber: null,
                address: null,
                city: null,
                borrowerState: null,
                zipcode: null,
                error: false,
                postingData: false
            };
        case newLoanConstants.PERSONAL_INFORMATION_FAILURE:
            return {
                error: true
            };
        case newLoanConstants.FINANCIAL_INFORMATION_REQUEST:
            return {
                error: false,
                postingData: false
            };
        case newLoanConstants.FINANCIAL_INFORMATION_SUCCESS:
            return {
                error: false,
                postingData: false
            };
        case newLoanConstants.FINANCIAL_INFORMATION_FAILURE:
            return {
                error: true,
                postingData: false
            };
        case newLoanConstants.CONFIRMATION_SUMMARY_REQUEST:
            return {
                branchDetails: null,
                error: false,
                postingData: false
            };
        case newLoanConstants.CONFIRMATION_SUMMARY_SUCCESS:
            return {
                error: false,
                postingData: false
            };
        case newLoanConstants.CONFIRMATION_SUMMARY_FAILURE:
            return {
                error: true,
                postingData: false
            };
        case newLoanConstants.APPLICATION_CONFIRMATION_REQUEST:
            return {
                branchDetails: null,
                error: false,
                postingData: false
            };
        case newLoanConstants.APPLICATION_CONFIRMATION_SUCCESS:
            return {
                postingData: false
            };
        case newLoanConstants.APPLICATION_CONFIRMATION_FAILURE:
            return {
                error: true,
                postingData: false
            };
        case newLoanConstants.PRE_APPROVAL_REQUEST:
            return {
                firstName: action.firstName,
                lastName: action.lastName,
                email: action.email,
                mobilePhoneNumber: action.mobilePhoneNumber,
                borrowerState: action.borrowerState,
                requestedAmount: action.requestedAmount
            };
        case newLoanConstants.PRE_APPROVAL_SUCCESS:
            return {
                firstName: action.firstName,
                lastName: action.lastName,
                email: action.email,
                mobilePhoneNumber: action.mobilePhoneNumber,
                borrowerState: action.borrowerState,
                requestedAmount: action.requestedAmount,
                preApprovalCode: action.preApprovalCode,
                preApproved: true
            };
        case newLoanConstants.NEW_LOAN_UPLOAD_TOKEN_FAILURE:
            return {
                errorString: action.errorString
            };
        case newLoanConstants.NEW_LOAN_TOKEN_SUCCESS:
            sessionStorage.setItem("NewLeadUser", JSON.stringify(action.leadByToken));
            
            return {
                tokenIsValid: true,
                leadId: action.leadByToken.leadId,
                applicationNumber: action.leadByToken.applicationNumber,
                email: action.leadByToken.email,
                mobilePhoneNumber: action.leadByToken.phone,
                firstName: action.leadByToken.firstName,
                lastName: action.leadByToken.lastName,
                zipcode: action.leadByToken.postalCode,
                preApprovalOffer: action.leadByToken.preApprovalOffer
            };
        case newLoanConstants.NEW_LOAN_TOKEN_FAILURE:
            return {
                errorString: action.errorString
            };
        case newLoanConstants.ACCOUNT_NOT_FOUND:
            return {
                errorString: action.errorString
            };
        case newLoanConstants.SET_WORKING: {
            return {
                error: false, 
                postingData: true
            }
        }
        case newLoanConstants.VALIDATE_STATE_FAILURE:
            return {
                errorString: action.errorString
            };
        case newLoanConstants.VALIDATE_STATE_SUCCESS:
            return {
                state: action.state,
                minLoanAmount: action.minLoanAmount,
                maxLoanAmount: action.maxLoanAmount,
                doesBusinessInState: action.doesBusinessInState
            };
        case refinanceIncreaseLoanConstants.REFINANCE_LOAN_LOADING:
            return {
                ...state,
                refinanceLoading: !state.refinanceLoading
            };
        case refinanceIncreaseLoanConstants.REFINANCE_LOAN_PERSONAL_INFORMATION_REQUEST:
                return {
                    firstName: action.personalInformation.firstName,
                    lastName: action.personalInformation.lastName,
                    monthOfBirth: action.personalInformation.monthOfBirth,
                    dayOfBirth: action.personalInformation.dayOfBirth,
                    yearOfBirth: action.personalInformation.yearOfBirth,
                    dateOfBirth: action.personalInformation.dateOfBirth,
                    email: action.personalInformation.email,
                    confirmEmail: action.personalInformation.confirmEmail,
                    mobilePhoneNumber: action.personalInformation.mobilePhoneNumber,
                    address: action.personalInformation.address,
                    city: action.personalInformation.city,
                    borrowerState: action.personalInformation.borrowerState,
                    zipcode: action.personalInformation.zipcode,
                    error: false,
                    postingData: false
                };    
        case refinanceIncreaseLoanConstants.REFINANCE_LOAN_FINANCIAL_INFORMATION_REQUEST:
            return {
                ...state,
                error: false,
                errorString: "",
                postingData: false
            };
        case refinanceIncreaseLoanConstants.REFINANCE_LOAN_FUNDING_REQUEST:
                return {
                    ...state,                  
                    error: false,
                    errorString: "",
                    postingData: false
                };    
        case newLoanConstants.NEW_LOAN_UNEXPECTED_ERROR:
            return {
                errorString: action.errorString
            };
        case newLoanConstants.PERSONAL_INFO_ERROR_CHECK:
            const { errorState } = action;
            let keys = Object.keys(errorState);
            let key = keys[0];
            return {
                ...state,
                [key]: errorState[key]
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/NewLoan..reducer.js